import { Injectable } from '@angular/core';
import { AResourceService } from './a-resource.service';
import { StateModel } from '../../models/resources/state.model';
import { LanguageService } from './language.service';
import { UrlParamModel } from '../../models/url-param.model';

@Injectable({
  providedIn: 'root',
})
export class StateService extends AResourceService<StateModel> {
  constructor(private languageService: LanguageService) {
    super('/states', false);
  }

  protected override getDefaultListParams(): UrlParamModel[] {
    const code = this.languageService.activeLanguage()?.code;
    if (!code) {
      return [];
    }
    return [{ key: 'lang', value: code }];
  }
}
